import { ErrorCode, type FileError } from 'react-dropzone';

export function getInitials(name: string) {
	if (!name) {
		return '';
	}

	const words = name.trim().split(/\s+/).filter(Boolean);

	if (words.length === 0) {
		return '';
	}

	if (words.length > 1) {
		const firstInitial = words?.[0]?.[0];
		const secondInitial = words?.[1]?.[0];
		return `${firstInitial}${secondInitial}`.toUpperCase();
	}

	const singleWord = words[0];
	return singleWord?.substring(0, 2).toUpperCase();
}

export const numberWithDelimeter = (
	val: string | number | null,
	delimeter = '.'
) => (val ? val?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimeter) : '');

export const onFileRejected = ({
	code,
	type
}: {
	code?: FileError['code'],
	type: 'image' | 'pdf'
}) => {
	const err = 'Format file tidak didukung. Gunakan format: '.concat(
		type === 'image' ? 'JNG, JPEG, PNG' : 'PDF'
	);
	if (code === ErrorCode.FileInvalidType) return err;
	return err + ' (Maks. 5 MB)';
};

export const formatNpwp = (input: string | null) => {
	if (!input) return null;

	const digits: string = input.replaceAll(/\D/g, '');
	const chars: string[] = digits.split('');

	const separators: Record<number, string> = {
		2: '.',
		5: '.',
		8: '.',
		9: '-',
		12: '.'
	};

	let result = '';

	for (let i = 0; i < chars.length && i < 15; i++) {
		if (separators[i]) {
			result += separators[i];
		}
		result += chars[i];
	}

	return result;
};

export function extractFileParts(filename: string) {
	const lastDotIndex = filename.lastIndexOf('.');

	if (lastDotIndex <= 0) {
		return { fileName: filename, fileExt: '' };
	}

	return {
		fileName: filename.substring(0, lastDotIndex),
		fileExt: filename.substring(lastDotIndex + 1)
	};
}
